import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import ShopThumb from './ShopThumb';
import { commissionAdapter, premiumContentAdapter } from '../Shop/Adapters';
import { ShopThumbType } from './types';
const ShopThumbFactory = (_param)=>{
    var { type } = _param, props = _object_without_properties(_param, [
        "type"
    ]);
    let adapterType = undefined;
    if (type) {
        adapterType = type;
    } else {
        if (props.deviation.hasOwnProperty('commission')) {
            adapterType = ShopThumbType.COMMISSION;
        } else if (props.deviation.hasOwnProperty('pcp')) {
            adapterType = ShopThumbType.PCP;
        }
    }
    let shopThumbProps;
    switch(adapterType){
        case ShopThumbType.COMMISSION:
            shopThumbProps = commissionAdapter(props);
            break;
        case ShopThumbType.PCP:
            shopThumbProps = premiumContentAdapter(props);
            break;
        default:
            shopThumbProps = props;
    }
    return /*#__PURE__*/ React.createElement(ShopThumb, shopThumbProps);
};
export default ShopThumbFactory;

//# sourceMappingURL=factory.js.map